import SearchAdPage from '@/components/google-ads/search/SearchAdPage';
import { TRAFFIC_OBJECTIVE } from './trafficObjective';

/** ADD ADS TO A TRAFFIC AD GROUP — /google-ads/traffic/create/ad */
export default function CreateTrafficAd() {
  return <SearchAdPage objective={TRAFFIC_OBJECTIVE} />;
}
